export default "Lav raslepinde med valnøddeskaller og grene. Brug dem som instrumenter til at lave magisk stenalder musik!";